import React from "react"
import { Link, graphql } from "gatsby"
import { css } from "react-emotion"
import Layout from "../components/layout"
import Img from "gatsby-image"
import styles from "./index.module.css"

export default ({ data }) => {
  return (
    <Layout>
      <div>
        {data.allMarkdownRemark.edges.map(({ node }) => (
          <div className={styles.listItem} key={node.id}>
            <h2>
              {node.frontmatter.title}{" "}
              <span
                className={css`
                  color: #bbb;
                `}
              >
              </span>
            </h2>
            <p>{node.excerpt}</p>
            { node.frontmatter.post_image.childImageSharp != null ? 
              <Img fluid={node.frontmatter.post_image.childImageSharp.fluid} />
              :
              <div className="row">
                <div className="col-md-6 col-xs-12">
                  <div className={node.frontmatter.device ? styles.device : styles.iphoneCase}>
                    <img className={node.frontmatter.device ? styles.gifDevice : styles.gif} alt="" src={node.frontmatter.post_image.publicURL} />
                  </div>
                </div>
                <div className="col-md-6 col-xs-12">
                  <p dangerouslySetInnerHTML={{__html: node.frontmatter.description }} />
                </div>
              </div>
            }
          </div>
        ))}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: ASC }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            description
            device
            date(formatString: "DD MMMM, YYYY")
            post_image {
              publicURL
              childImageSharp {
                fluid(maxWidth: 1000) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
          	slug
          }
          excerpt
        }
      }
    }
  }
`
